import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import FormSwitch from "jd-library/FormSwitch";
import Popover from "jd-library/Popover";
import style from './switch-button-with-moving-input.scss';

const SwitchButtonWithMovingInput = (props) => {
    const { type, label, content, inputProps, deviceData, variant } = props;
    const [inputField, toggleInputField] = useState(null);
    const [inputVal, setInput] = useState('');
    const [popRef, setPopRef] = useState(null);
    let containerRef = useRef();
    useEffect(() => {
        if (inputProps) {
            setInput(inputProps.value);
            toggleInputField(inputProps.toggle);
        }
    }, []);
    return (
        <>
            <div key={type} className={`${style["switch-holder"]} `} ref={containerRef}>
                <div className={`${style["heading-popover"]} ${popRef ? style["active-popover"] : ''}`}>
                    {label}
                    <Popover
                        className={style["popover-div"]}
                        containerEle={containerRef}
                        content={<div ref={setPopRef} className="popover-holder">{content}</div>}
                        eventType='click'
                        fixToTop={props.fixToTop}
                    >
                        <div className={style["popover-icon"]}>
                            <i className="icon-Info"></i>
                        </div>
                    </Popover>
                </div>
                <div className={style["form-switch-holder"]}>
                    <FormSwitch
                        checked={inputField}
                        onClick={() => { inputProps.onChange(type, inputVal, !inputField); toggleInputField(!inputField); }}
                        variant={variant}
                        showToggleStatus={variant?true:false}
                    />
                </div>
            </div>
            {!inputField ? <InputWithMovingLabel
                holderClass={inputProps.class}
                label={inputProps.inputLabel}
                input={{
                    type: deviceData.isIphone ? "number" : "tel",
                    value: inputVal,
                    onChange: (event) => {
                        if (/^\d{0,10}$/.test(event.target.value)) {
                            setInput(event.target.value);
                        } else {
                            // console.log("Wrong Input Value", event.target.value);
                        }
                    },
                    autoFocus: inputField==false,
                    onBlur: (event) => { setInput(event.target.value); inputProps.onChange(type, event.target.value, inputField); }
                }}
            /> : null}
        </>
    );
};

SwitchButtonWithMovingInput.defaultProps = {
    inputProps: {
        toggle: false,
        value: ''
    }
}

SwitchButtonWithMovingInput.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    inputProps: PropTypes.object.isRequired
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        deviceData: state.deviceData,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchButtonWithMovingInput);
